import React, { useState, useEffect } from 'react';
import axios from '../../api/api';
import { Link } from 'react-router-dom';
import { MdOutlineBlock, MdModeEdit, MdDelete } from 'react-icons/md';
import Pagination from '../Users/Pagination';
import { toast } from 'react-toastify';

const MyUploads = () => {
  const [myUpload, setMyUpload] = useState([]);
  const [searchUpload, setSearchUpload] = useState('');
  const searchU = (e) => {
    setSearchUpload(e.target.value);
  };
  const mySearch = myUpload.filter((myUpload) => {
    return Object.keys(myUpload).some((key) =>
      myUpload[key].toString().toLowerCase().includes(searchUpload.toLowerCase())
    );
  });
  // User is currently on this page
  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage] = useState(10);

  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = mySearch.slice(indexOfFirstRecord, indexOfLastRecord);
  const nPages = Math.ceil(mySearch.length / recordsPerPage);


  // current user details
  const user = window.localStorage.getItem('token');
  const creatorId = JSON.parse(user).data._id;
  // get all my uploads
  const getMyUploads = async () => {
    const response = await axios.get(`/api/v3/contents/${creatorId}/mycontents`);
    setMyUpload(response.data);
    console.log(response)
  };

  const deleteContent = async (id) => {
    const confirmed = window.confirm('Are you sure you want to delete this video');
    if (confirmed) {
      try {
        await axios.delete(`/api/v3/contents/delete/${id}`);
        toast.success('Video Deleted')
        getMyUploads();
      } catch (error) {
        toast.error('Delete failed')
        console.log(error);
      }
    }
  };

  useEffect(() => {  
    getMyUploads();
    // eslint-disable-next-line
  }, []);

  return (
    <div>
      <div className='mx-auto p-4 lg:container'>
        <div className='bg-white p-4 rounded-lg'>
          <div className='flex justify-between p-4'>
            <p className='text-2xl'>My Uploads</p>
            <div>
              <Link className='bg-blue-600  text-white px-4 py-2 hover:bg-blue-400' to='/admin/video-uploads'>Add new upload</Link>
            </div>
          </div>
          <hr />
          <div className='flex justify-between p-4 '>
            <p className='text-lg'>Showing {currentRecords.length} entries</p>
            <div>
              <form action=''>
                <div className='items-center'>
                  <label htmlFor=''>
                    <input
                      type='search'
                      className='ml-2 px-2 py-1 bg-slate-100 border  border-slate-300 focus:outline-none focus:border-sky-500 focus:ring-sky-500 block w-full focus:ring-1'
                      required
                      placeholder='Search Video'
                      value={searchUpload}
                      onChange={searchU.bind(this)}
                    />
                  </label>
                </div>
              </form>
            </div>
          </div>
          <div className='overflow-x-auto border border-slate-300 h-[40em]'>
            {
              mySearch.length > 0
                ? (
                  <table className='w-full text-justify table-auto'>
                    <thead>
                      <tr className='border-b border-slate-500'>
                        <th className='py-3 px-6'>No.</th>
                        <th className='py-3 px-6'>Movie name</th>
                        <th className='py-3 px-6'>Movie Type</th>
                        <th className='py-3 px-6'>Producers name</th>
                        <th className='py-3 px-6'>Film Budget</th>
                        <th className='py-3 px-6'>Percentage <br /> agreement</th>
                        <th className='py-3 px-6'>Lock amount</th>
                        <th className='py-3 px-6'>Cover Image</th>
                        <th className='py-3 px-6'>Status</th>
                        <th className='py-3 px-6'>Created At</th>
                        <th className='py-3 px-6'>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentRecords.map((video, index) => (
                        <tr key={video._id}>
                          <td className='py-2 px-6'>{index + 1}</td>
                          <td className='py-2 px-6'>{video.movieName}</td>
                          <td className='py-2 px-6'>{video.movieType}</td>
                          <td className='py-2 px-6'>{video.movieProducer}</td>
                          <td className='py-2 px-6'>{video.filmBudget}</td>
                          <td className='py-2 px-6'>{video.percentageAgreement}</td>
                          <td className='py-2 px-6'>{video.movieLock}</td>
                          <td className='py-4 px-6'><img width={50} src={`https://naijaserver.cleverapps.io/api/v3/image/${video.coverPhoto}`} alt='' /></td>
                          <td className='py-2 px-6'>
                            {video.reviewStatus === 'Approved' ? (
                              <span className='bg-green-400 text-neutral-100 py-0.5 px-1.5 rounded-full'>{video.reviewStatus}</span>
                            ) : video.reviewStatus === 'Rejected' ? (
                              <span className='bg-red-400 text-neutral-100 py-0.5 px-1.5 rounded-full'>{video.reviewStatus}</span>
                            ) : (
                              <span className='bg-blue-400 text-neutral-100 py-0.5 px-1.5 rounded-full'>{video.reviewStatus}</span>
                            )}
                          </td>
                          <td className='py-2 px-6'>{new Date(video.createdAt).toLocaleString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false })}</td>
                          <td className='py-2 px-6'> 
                            <button onClick={() => deleteContent()} disabled className='text-blue-700 p-1 text-xl hover:text-blue-500'><MdModeEdit /></button>
                            <button onClick={() => deleteContent(video._id)} className='text-red-500 p-1 text-xl hover:text-red-900'><MdDelete /></button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  )
                : (
                  <div className='bg-[#EEF1FF] h-full grid place-items-center'>
                    <div className='grid place-items-center'>
                      <h2><MdOutlineBlock /></h2>
                      <h4>No Data</h4>
                    </div>
                  </div>
                  )
            }
          </div>
          <Pagination
            nPages={nPages}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
          />
        </div>
      </div>
    </div>
  );
};

export default MyUploads;
